import React, { useState, useEffect } from 'react';
import { Input } from 'antd';
import GenericDialog from "../../common/GenericDialog";
import axios from "axios";

const EditUserEmailDialog = ({ visible, user, handleClose }) => {
    const [newEmail, setNewEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (visible && user?.email) {
            setNewEmail(user.email);
            setErrors({});
        }
    }, [visible, user]);

    const editUserEmail = async (userId, email) => {
        setLoading(true);
        setErrors({});

        try {
            const response = await axios.post('/controlCentre/editUsersEmail.action', {}, {
                params: { userId, email }
            });

            if (!response.data.valid) {
                setErrors({ email: response.data.message });
                setLoading(false);
                return false;
            } else {
                setLoading(false);
                return response.data.user;
            }
        } catch (error) {
            setLoading(false);
            if (error.response?.data?.message) {
                setErrors({ general: error.response.data.message });
            } else {
                setErrors({ general: 'There was an error updating emails' });
            }
            return false;
        }
    };

    const handleEditEmail = async () => {
        if (!newEmail.trim()) {
            setErrors({ email: 'Please enter a valid email address.' });
            return;
        }

        const result = await editUserEmail(user.userId, newEmail.trim());
        if (result) {
            // Pass the updated user data back
            handleClose(result);
        }
    };

    const handleCancel = () => {
        setNewEmail(user?.email || '');
        setErrors({});
        handleClose(false);
    };

    return (
        <GenericDialog
            title={`Edit user email`}
            open={visible}
            dialogWidth={600}
            onClose={handleCancel}
            buttons={[
                {
                    name: 'Cancel',
                    callback: handleCancel,
                    extraProps: { type: 'text', disabled: loading }
                },
                {
                    name: 'Update Email',
                    callback: handleEditEmail,
                    extraProps: {
                        type: 'primary',
                        disabled: loading,
                        loading: loading
                    }
                }
            ]}
        >
            <p>Update the email address for <strong>{user?.fullName}</strong>. This will change their login credentials.</p>
            <br/>
            {errors.general && (
                <div role="alert" aria-live="polite" className={'ch-error-text'}>
                    {errors.general}
                </div>
            )}
            <div style={{ marginBottom: '16px' }}>
                <label htmlFor="email-input" style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                    Email Address:
                </label>
                <Input
                    id="email-input"
                    type="email"
                    value={newEmail}
                    onChange={(e) => setNewEmail(e.target.value)}
                    placeholder="Enter new email address"
                    status={errors.email ? 'error' : ''}
                    aria-invalid={errors.email ? 'true' : 'false'}
                    aria-describedby={errors.email ? 'email-error' : undefined}
                />
                {errors.email && (
                    <div id="email-error" role="alert" aria-live="polite" className={'ch-error-text'}>
                        {errors.email}
                    </div>
                )}
            </div>
        </GenericDialog>
    );
};

export default EditUserEmailDialog;